const actions = {
}

export default actions



// WEBPACK FOOTER //
// ./module/passport/src/store/actions.js